module.exports = __webpack_public_path__ + "static/amazon-e5acd1a15bddc491b7324ca40b236b1a.png";